<ng-content></ng-content>

@if (getLoadingState()) {
  <loading-indicator></loading-indicator>
}
